import ImageAmount from './View/ImageAmount.view';
export default ImageAmount;
